export class TimeoutError extends Error {
  constructor(ms: number) {
    super(`Operation timed out after ${String(ms)}ms`);
    this.name = 'TimeoutError';
  }
}

export const withTimeout = <T>(promise: Promise<T>, ms: number): Promise<T> => {
  return Promise.race([
    promise,
    new Promise<T>((_, reject) => {
      setTimeout(() => {
        reject(new TimeoutError(ms));
      }, ms);
    }),
  ]);
};

export const sleep = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
